module.exports = __webpack_public_path__ + "static/media/Rectangle 62.af5c9c65.png";